import { styled } from '@linaria/react';
import { motion } from 'framer-motion';

import { BREAKPOINTS } from '@/constants';

import GridDemo from './GridDemo';
import Item from './Item';
import { GridStructure as GridStructureShared } from './Grid.shared';

function InitialExample() {
  return (
    <GridDemo>
      {({ isPerspectiveEnabled }) => {
        return (
          <Wrapper>
            <Layer
              style={{
                transform: isPerspectiveEnabled
                  ? 'translateX(var(--x)) skewY(18deg) scaleX(0.85)'
                  : 'translateX(0%) skewY(0deg) scaleX(1)',
              }}
            >
              <GridStructure>
                <GridLabel
                  style={{
                    opacity: isPerspectiveEnabled ? 1 : 0,
                    transform: `translateY(${
                      isPerspectiveEnabled ? -145 : -70
                    }%)`,
                  }}
                >
                  <span>Grid Parent</span>
                </GridLabel>
                <GridRow
                  style={{ gridColumn: '1 / -1', gridRow: 1 }}
                />
                <GridRow
                  style={{ gridColumn: '1 / -1', gridRow: 2 }}
                />
                <GridColumn
                  style={{ gridColumn: '1', gridRow: '1 / -1' }}
                />
              </GridStructure>
            </Layer>
            <Layer
              style={{
                transform: isPerspectiveEnabled
                  ? 'translateX(calc(var(--x) * -1)) skewY(18deg) scaleX(0.85)'
                  : 'translateX(0%) skewY(0deg) scaleX(1)',
              }}
            >
              <ChildWrapper>
                <ChildLabel
                  style={{
                    opacity: isPerspectiveEnabled ? 1 : 0,
                    transform: `translateY(${
                      isPerspectiveEnabled ? -130 : -50
                    }%)`,
                  }}
                >
                  <span>Grid Children</span>
                </ChildLabel>
                <Item
                  layout={false}
                  style={{
                    opacity: isPerspectiveEnabled ? 0.8 : 1,
                    gridColumn: '1 / -1',
                    gridRow: 1,
                  }}
                  textWrapperStyle={{
                    transform: 'translateY(-1.5px)',
                  }}
                >
                  {'<Header>'}
                </Item>
                <Item
                  layout={false}
                  style={{
                    opacity: isPerspectiveEnabled ? 0.8 : 1,
                    gridColumn: 1,
                    gridRow: 2,
                  }}
                  textWrapperStyle={{
                    transform: 'translateY(-1.5px)',
                  }}
                >
                  {'<Nav>'}
                </Item>
                <Item
                  layout={false}
                  style={{
                    opacity: isPerspectiveEnabled ? 0.8 : 1,
                    gridColumn: 2,
                    gridRow: 2,
                  }}
                  textWrapperStyle={{
                    transform: 'translateY(-1.5px)',
                  }}
                >
                  {'<Main>'}
                </Item>
                <Item
                  layout={false}
                  style={{
                    opacity: isPerspectiveEnabled ? 0.8 : 1,
                    gridColumn: '1 / -1',
                    gridRow: 3,
                  }}
                  textWrapperStyle={{
                    transform: 'translateY(-1.5px)',
                  }}
                >
                  {'<Footer>'}
                </Item>
              </ChildWrapper>
            </Layer>
          </Wrapper>
        );
      }}
    </GridDemo>
  );
}

const Wrapper = styled.div`
  position: relative;
  width: 90%;
  max-width: 350px;
  height: 300px;
  margin: 96px auto;
`;

const Layer = styled(motion.div)`
  --x: 15%;
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  transition: transform 500ms;
  will-change: transform;

  @media ${BREAKPOINTS.smAndSmaller} {
    --x: 12%;
  }
`;

const ChildWrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-rows: 25% 60% 15%;
  grid-template-columns: 90px 1fr;
  width: 100%;
  height: 100%;
  padding: 2px;
`;

const LayerLabel = styled.div`
  position: absolute;
  top: 0;
  padding: 0 4px;
  font-weight: var(--font-weight-bold);
  color: hsl(260deg 100% 80%);
  transition:
    opacity 300ms,
    transform 500ms cubic-bezier(0.17, 0.67, 0.47, 1);

  @media ${BREAKPOINTS.smAndSmaller} {
    font-size: 0.875rem;
    padding: 0;
  }
`;

const ChildLabel = styled(LayerLabel)`
  left: 0;
`;

const GridLabel = styled(LayerLabel)`
  right: 0;
`;

const GridStructure = styled(GridStructureShared)`
  grid-template-rows: 25% 60% 15%;
  grid-template-columns: 90px 1fr;
`;

const GridRow = styled.div`
  border: 1px solid transparent;
  border-bottom: 2px dashed var(--color-gray-300);
  transform: translateY(1px);
`;
const GridColumn = styled.div`
  border: 1px solid transparent;
  border-right: 2px dashed var(--color-gray-300);
  transform: translateX(1px);
`;

export default InitialExample;
